module.exports = __webpack_public_path__ + "b0bf3ab56054684c3f0c857a74fc7ac7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/Spotin_SymbolS_Ring_Off_White_Big_RGB.png
// module id = 165
// module chunks = 0